import { useQuery } from "@tanstack/react-query";
import { getTaskList } from "../api/letterBox.api";
import { letterBoxListResult } from "../api/types";
import { useLetterBoxFilter } from "../context/FilterContext";

export function useEmailList() {
  const { filters } = useLetterBoxFilter();

  return useQuery<letterBoxListResult>({
    queryKey: ["letterBox-list", filters],
    queryFn: () => getTaskList(filters),
    staleTime: 30_000,
  });
}
